import { useI18n } from 'vue-i18n'

import useBlProviders from '@/composables/providers/useBlProvider'
import CounterpartiesGroupsDt from '@/services/dataTransferModules/counterpartiesGroupsDt'

export default function useCounterpartiesGroups() {
	const counterpartiesGroupsDt = new CounterpartiesGroupsDt()

	const { t: $t } = useI18n()

	const {
		loadEntityFlags: flags,

		entities: fullCounterpartiesGroups,
		getEntities: getCounterpartiesGroups,

		createEntity: createCounterpartiesGroups,

		entity: counterpartiesGroups,
		getEntity: getCounterpartiesGroup,

		entityPopup: counterpartiesGroupsPopup,
		getEntityPopup: getCounterpartiesGroupsPopup,

		entityPreview: counterpartiesGroupsPreview,
		getEntityPreview: getCounterpartiesGroupsPreview,

		patchEntity: patchCounterpartiesGroups,
		updateEntity: putCounterpartiesGroups,

		deleteEntity: deleteCounterpartiesGroup,
	} = useBlProviders(
		counterpartiesGroupsDt,
		Object.assign({
			showErrorNotificationForLoadingAllEntities: true,
			errorNotificationTextForLoadingAllEntities: $t('Error loading counterparties group'),

			showErrorNotificationForCreatingEntity: true,
			errorNotificationTextForCreatingEntity: $t('Error when adding counterparties group'),

			showErrorNotificationForLoadingOneEntity: true,

			showErrorNotificationForUpdatingEntity: true,
			errorNotificationTextForUpdatingEntity: $t('Error when editing a group of counterparties'),

			showErrorNotificationForDeletingEntity: true,
		})
	)

	return {
		flags,
		fullCounterpartiesGroups,
		counterpartiesGroupsPreview,
		counterpartiesGroupsPopup,
		counterpartiesGroups,
		getCounterpartiesGroups,
		getCounterpartiesGroup,
		getCounterpartiesGroupsPreview,
		getCounterpartiesGroupsPopup,
		createCounterpartiesGroups,
		putCounterpartiesGroups,
		patchCounterpartiesGroups,
		deleteCounterpartiesGroup,
	}

}
